import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';


class AssignUserToTeam {
  constructor($scope, $window, userInTeamService, context, userInGroupService) {
    'ngInject';

    this.$scope = $scope;
    this.$window = $window;
    this.userInTeamService = userInTeamService;
    this.userInGroupService = userInGroupService;
    this.context = context;
    this.currentTab = 'general';
    this.addMode = 'existingUser';
    this.userExists = false;
  }

  $onInit() {
    this.loading = true;

    this.loadTemplate();
    this.$scope.$watch('$ctrl.template.workingDayInherit', () => this.updateWeekDayConfig());
  }

  loadTemplate() {
      this.userInTeamService.getAssignUserToTeamTemplate({ teamId: this.resolve.teamId })
          .then((template) => {
              if (template === null) {
                  ttb.Notifications.ShowErrorMessage('Team Configuration', 'Cannot assign user');
                  this.dismiss();

                  return;
              }

              this.template = template;
              this.roleOptions = template.roles;
              this.selectedRole = find(this.roleOptions, x => x.id === this.template.roleId);
              this.userOptions = template.users;
              this.updateWeekDayConfig();
              this.loading = false;
              this.updatelicense();
          });
  }

  add() {
      if (this.addMode === 'existingUser') {
          this.loading = true;

          this.userInTeamService.assingUserAndTeam({
                  userId: this.selectedUser.id,
                  teamId: this.template.teamId,
                  projectId: this.template.projectId,
                  isActive: this.template.isActive,
                  roleId: this.selectedRole.id,
                  workingDayInherit: this.template.workingDayInherit,
                  workingTimings: this.template.workingTimings,
                  dayOverrides: this.template.dayOverrides,
              })
              .then(() => {
                  this.loading = false;

                  this.close({
                      $value: {
                          userId: this.selectedUser.id,
                          teamId: this.template.teamId,
                      },
                  });
              },
              () => {
                  this.loading = false;
              });
      }
      else if (this.addMode === 'invite') {
          this.loading = true;

          this.userInGroupService.inviteUser({
                  email: this.template.email,
                  description: this.template.description,
                  projectId: this.template.projectId,
                  teamId: this.template.teamId,
                  roleId: this.template.roleId
              })
              .then(data => {
                      this.loading = false;

                      if (data && data.statusCode <= 0) {
                          ttb.Notifications.ShowErrorMessage('Team Configuration', data.statusMessage);
                      }
                      else this.close({
                          $value: {
                              teamId: this.template.teamId
                          }
                      });
                  },
                  () => {
                      this.loading = false;
                  });
      }
  }

  onTabChange(tab) {
    this.currentTab = tab;
  }

  updateWeekDayConfig() {
    if (!this.template) return;
    this.currentWeekDayConfig = cloneDeep(this.template.workingDayInherit
      ? this.template.teamWorkingTimings.weekDayConfig
      : this.template.workingTimings.weekDayConfig);
  }

  onDaysOfWeekChange() {
    this.updateWeekDayConfig();
  }

    emailChanged() {
        if (this.template.email) {
            this.userChecking = true;
            this.userInGroupService.isUserExists(this.template.projectGroupId, this.template.email)
                .then((data) => {
                    this.userExists = data;
                    this.userChecking = false;
                });
        }
    }

    formValid() {
        return (this.addMode === 'invite' && this.template.userCount < this.license.maxNumberOfUsers && !this.userExists && !this.userChecking) ||
            (this.addMode === 'existingUser' && this.selectedUser && this.selectedUser.id);
    }

    updatelicense(forceReload) {
        if ((!this.license || forceReload) && this.template) {
            this.loading = true;

            this.context.getlicense(this.template.projectGroupId)
                .then((license) => {
                    this.loading = false;
                    this.license = license;

                    this.userCountCloseToLimint = (this.license.maxNumberOfUsers - this.template.userCount)/this.license.maxNumberOfUsers <= 0.1;
 
                });
        }
    }
}

export default AssignUserToTeam;



// WEBPACK FOOTER //
// ./components/popups/user-popup/assign-user-to-team/assign-user-to-team.controller.js